// src/hooks/useFinancialsOverview.js
// SCREENER-FINANCIALS — updated this pass: estimatedUpcoming is now
// { thisWeek: [], thisMonth: [] } (week/month bucketed server-side),
// default shape updated to match so EstimatedUpcoming.jsx never sees
// undefined before the fetch resolves.

import { useState, useEffect } from 'react';
import apiFetch from '../utils/apiFetch';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export function useFinancialsOverview() {
  const [biggestMovers, setBiggestMovers]         = useState([]);
  const [estimatedUpcoming, setEstimatedUpcoming] = useState({ thisWeek: [], thisMonth: [] });
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState('');

  useEffect(() => {
    setLoading(true);
    setError('');
    apiFetch(API_URL + '/api/financials/overview')
      .then(r => r.json())
      .then(res => {
        if (!res.success) { setError(res.message || 'Financials data unavailable'); return; }
        setBiggestMovers(res.biggestMovers || []);
        setEstimatedUpcoming(res.estimatedUpcoming || { thisWeek: [], thisMonth: [] });
      })
      .catch(() => setError('Failed to load financials overview'))
      .finally(() => setLoading(false));
  }, []);

  return { biggestMovers, estimatedUpcoming, loading, error };
}
